/* eslint-disable react/no-set-state */
import React, { Component } from 'react';

export default class NoDataHolder extends Component {
  render () {
    const style = {
      backgroundColor: '#ffffff',
      border: '1px solid darkgrey',
      borderRadius: '10px',
      padding: '10px'
    };
    const containerStyle = {
      display: 'flex',
      justifyContent: 'center',
      maxHeight: '45px'
    };
    return (
      <div className='align-center' style={containerStyle}>
        <span style={style}>No Rows To Show</span>
      </div>
    );
  }
}
